import React, { FC, ReactElement } from 'react';
import PostItem from './PostItem';
import Link from 'next/link';

export type Post = {
  id: number;
  image: any;
  date: string;
  title: string;
  url: string;
  likes?: number;
  views?: number;
  tag?: string;
}

type PostsProps = {
  articles: Post[];
}

const Posts: FC<PostsProps> = ({ articles }: PostsProps): ReactElement => {
  const postsElements = articles.map((item: Post) => {
    return (
      <PostItem
        key={item.id}
        image={item.image}
        date={item.date}
        title={item.title}
        url={item.url}
      />
    );
  });

  return (
    <div className="freight-dictionary__posts">
      <div className="container">
        <h3 className="freight-dictionary__posts-title">
          <span className="freight-dictionary__posts-title-text">
            Related blog posts{TitleSvg}
          </span>
          <Link className="new-link arrow" href="/blog">
            See all
            <svg className="link-arrow directionRight" viewBox="0 0 10 10" aria-hidden="true">
              <path className="link-arrow__line" d="M1 5h7" />
              <path className="link-arrow__tip" d="M2 1l4 4-4 4" />
            </svg>
          </Link>
        </h3>
        <div className="freight-dictionary__posts-list">
          {postsElements}
        </div>
      </div>
    </div>
  );
};

export default Posts;

const TitleSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="110" height="97" viewBox="0 0 110 97" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M59.9196 80.7932C67.0364 85.3039 74.6251 89.3873 80.0468 96.0031C80.3709 96.3959 80.951 96.4556 81.347 96.1334C81.7398 95.8093 81.7995 95.2292 81.4773 94.8333C75.9283 88.0635 68.1908 83.8477 60.9082 79.2331C60.4789 78.958 59.9058 79.0877 59.6339 79.5189C59.3589 79.9481 59.4904 80.5182 59.9196 80.7932Z" fill="url(#paint0_linear_3392_87327)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M65.5679 69.919C69.0626 69.1996 72.451 69.1234 75.8824 70.1377C76.3724 70.2829 76.8852 70.0028 77.0315 69.5153C77.1747 69.0258 76.8937 68.5111 76.4068 68.3678C72.6758 67.2644 68.9964 67.3301 65.1977 68.1111C64.6972 68.2128 64.3741 68.7007 64.4785 69.201C64.58 69.6992 65.0706 70.0227 65.5679 69.919Z" fill="url(#paint1_linear_3392_87327)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M72.8831 43.5472C76.0397 40.6291 79.7342 39.0821 84.0496 38.9543C84.5584 38.939 84.9604 38.5135 84.9437 38.0034C84.9301 37.4951 84.5037 37.0934 83.9948 37.1088C79.2183 37.2513 75.125 38.9603 71.6298 42.1911C71.2546 42.5361 71.2342 43.1225 71.5787 43.4957C71.9262 43.8711 72.5111 43.8941 72.8831 43.5472Z" fill="url(#paint2_linear_3392_87327)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M40.1994 17.3862C39.1512 17.7402 38.1326 18.1881 37.1662 18.7359C36.7355 18.9796 35.8972 19.5435 35.4362 20.182C34.9425 20.8608 34.8231 21.6118 35.2587 22.3067C35.8377 23.2291 36.5289 23.5843 37.1952 23.6368C37.8365 23.6881 38.5122 23.4378 39.1442 22.9378C40.3516 21.9816 41.416 20.0514 41.8194 18.8273C42.8808 18.5446 43.9677 18.363 45.0644 18.2798C53.2328 17.6607 60.7391 24.2055 63.5612 34.1604C64.5483 37.6453 62.9567 42.7631 60.6311 47.9196C57.0111 55.9489 51.478 64.0222 49.9347 66.4342C49.555 67.0306 49.396 67.4245 49.3845 67.5154C49.3212 67.958 49.5288 68.2076 49.6915 68.3527C49.9289 68.5599 50.1714 68.6366 50.3956 68.6507C50.6997 68.6679 51.0182 68.5679 51.3052 68.291C51.4621 68.1371 51.6273 67.8908 51.7835 67.6164C51.8899 67.4248 51.9751 67.1969 52.0939 67.0851C52.8583 66.3717 53.6612 65.7089 54.4614 65.0363C57.1442 62.771 60.0043 60.8561 63.0018 59.0279C72.5254 53.2184 82.1915 46.8418 93.3401 44.7533C93.8401 44.6595 94.1725 44.1777 94.0775 43.6761C93.9856 43.1763 93.5033 42.8462 92.9999 42.9384C81.629 45.067 71.7533 51.5275 62.0402 57.4515C59.4908 59.0069 57.0377 60.6244 54.7054 62.4566C57.3212 58.3088 60.7802 52.47 63.1022 46.8604C65.1677 41.8716 66.2962 37.0443 65.3369 33.6566C62.2455 22.7513 53.8708 15.7591 44.925 16.439C43.9679 16.5121 43.0139 16.6517 42.0777 16.8623C42.3547 8.96272 36.7533 2.36614 28.8393 1.47136C28.3314 1.41322 27.8752 1.77847 27.817 2.28415C27.7621 2.79173 28.1253 3.24848 28.6331 3.30663C35.7645 4.11307 40.7428 10.205 40.1994 17.3862ZM39.4666 19.6465C38.9927 19.8547 38.5297 20.0876 38.075 20.3427C37.8328 20.4806 37.3897 20.7594 37.0688 21.1C36.9947 21.1804 36.9053 21.3223 36.8653 21.3887C37.0191 21.6276 37.1589 21.7821 37.3402 21.7958C37.566 21.8143 37.7764 21.6649 37.9978 21.4899C38.5541 21.0512 39.0759 20.3402 39.4666 19.6465Z" fill="url(#paint3_linear_3392_87327)"/>
    <defs>
      <linearGradient id="paint0_linear_3392_87327" x1="57.741" y1="82.6702" x2="66.4817" y2="74.5382" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"/>
        <stop offset="1" stopColor="#006FF1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_3392_87327" x1="64.1154" y1="69.3306" x2="76.9779" y2="66.7616" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"/>
        <stop offset="1" stopColor="#006FF1"/>
      </linearGradient>
      <linearGradient id="paint2_linear_3392_87327" x1="70.9892" y1="43.1851" x2="84.5018" y2="44.7058" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"/>
        <stop offset="1" stopColor="#006FF1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_3392_87327" x1="4.37276" y1="41.1623" x2="92.0987" y2="21.5007" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"/>
        <stop offset="1" stopColor="#006FF1"/>
      </linearGradient>
    </defs>
  </svg>
);